import { createApp } from 'vue';
import App from './App.vue';
import 'swiper/css';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vantUse from './utils/vantUse';
import { usI18n } from '@/local/index.js';
import { awsRumHandler } from '@/utils/awsRumHandler';
import { registerGlobComp } from './components/registerGlobComp';
import './assets/styles/reset.css';
import Vconsole from 'vconsole';
import { Bridge } from '@/utils/bridge';
awsRumHandler.initialize();
const app = createApp(App);

// Determine whether to add vconsole
Bridge.callFn('checkDebugMode', {}, ({ result }) => {
  if (!result) return;
  const vConsole = new Vconsole();
  app.use(vConsole);
});

vantUse(app);
registerGlobComp(app);
app.use(store).use(router).use(usI18n).mount('#app');
